
export const getNameByImage = (src: string) => {
  if (!src) return "";
  return src.split('/')[4].split('.')[0];
};
